// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Am-z","badgeLink":"Bm-z","category":"Cm-z"};